import { StyledRecheckIcon } from '@src/layouts/shared/Recheck/styles'
import { Toggle } from '@src/layouts/types'
import sunkist from '@src/styled/theme'
import { RECHECK_BUTTON } from '@src/utils/dataTestIds/index'
import * as React from 'react'
import { TriggerContainer, TriggerText } from '../styles'

const Trigger: React.FC<Toggle> = ({ active }) => (
  <TriggerContainer data-test={RECHECK_BUTTON}>
    <StyledRecheckIcon size="small" color={sunkist.colors.dark} />
    <TriggerText underline={active}>Recheck</TriggerText>
  </TriggerContainer>
)

export default Trigger



// WEBPACK FOOTER //
// ./src/layouts/shared/Recheck/Trigger.tsx